<template>
    <section id="prayer" class="Prayer white-text parallax">
        <div class="row container">
            <div class="col s12 center">
                <!-- <div class="title center">Need Prayer?</div> -->
                <div class="title"><img src="/assets/images/prayer.png"></div>
                <p>Are you in need of prayer, or know someone who has a need?<br>Let us know and we will pray together as a church and family.</p>      
                <div class="button-div">
                    <a class="waves-effect waves-light btn-large" href="mailto:houseoffirechristianchurch@gmail.com?subject=Please pray for...&body=Please provide you name, phone, and prayer request(s).">Share</a>
                    <PrayerRequest/>
                </div>      
            </div>
        </div>
    </section>
</template>

<script>
    // import Swal from 'sweetalert2';
    import PrayerRequest from '../../components/PrayerRequest.vue'

    export default {
        name: 'Prayer',
        components: { PrayerRequest },
        methods: {
            // openPrayerForm: function() {
            //     Swal.fire('Any fool can use a computer')
            // }
        }
    }
</script>

<style scoped>
    /* @import '//cdn.jsdelivr.net/npm/@sweetalert2/theme-material-ui/material-ui.css'; */

    section {
        padding: 8.5rem 0 6.5rem 0;
        background: url(/assets/images/prayer2.jpg);
        background-size: cover;
        min-height: 300px;
    }

    .parallax { 
        /* The image used */
        /* background-image: url("img_parallax.jpg"); */

        /* Set a specific height */
        /* height: 500px;  */

        /* Create the parallax scrolling effect */
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    p {
        font-size: 1.5rem;
        line-height: 1.25;
    }

    .button-div {
        margin-top: 2rem;
    }

    .btn-large {
        /* line-height: 58px; */
        /* font-size: 1.25rem; */
        /* padding: 0px 50px; */
        background: rgba(91,124,138, .7);
    }

    .btn-large:hover {
        color: #fff;
        background: rgba(91,124,138, 1);
    }
</style>